import CheckBox from './CheckBox';
import Radio from './Radio';
import Switch from './Switch';

export default {
  Switch,
  CheckBox,
  Radio
};
